// @flow
import React, { PureComponent } from 'react';

import Loading from 'components/fragments/Loading';
import { SUBJECT_FIELD_NAME } from 'constants/contactForm7Constants';
import { STATUS_LOADING, STATUS_SUCCESS } from 'constants/statusConstants';
import CF7Form from 'containers/contactForm7/CF7FormContainer';
import type { SingleContactFormType } from 'types/ContactForm7';
import type { Status } from 'types/Status';

import H3Title from './titles/h3Title';

export type StateProps = {
  singleContactForm: SingleContactFormType,
  sendStatus: Status,
  fetchStatus: Status
};

export type DispatchProps = {
  fetchCF7ContactForm: () => void,
  fetchSingleCF7FormContact: (id: number) => void,
  resetCF7ContactFormStatus: () => void
};

type Props = StateProps &
  DispatchProps & {
    currentThemeTitle: string,
    formId: number,
    initialValues: { [key: string]: any },
    slugTheme: string,
    title?: string,
    titleClass?: string,
    titleTag?: string
  };

type State = {
  initialValues: { [key: string]: any }
};

class ContactForm7 extends PureComponent<Props, State> {
  props: Props;

  state: State = {
    initialValues: {}
  };

  componentDidMount: () => void = () => {
    const { fetchCF7ContactForm, fetchSingleCF7FormContact, formId } = this.props;

    fetchCF7ContactForm();

    if (formId && formId !== -1) {
      fetchSingleCF7FormContact(formId);
    }
    this.setInitialValuesState();
  };

  componentDidUpdate(prevProps: Props, prevState: State) {
    const { currentThemeTitle: prevCurrentThemeTitle, formId: prevFormId, sendStatus: prevSendStatus } = prevProps;
    const {
      currentThemeTitle,
      fetchSingleCF7FormContact,
      formId,
      sendStatus,
      resetCF7ContactFormStatus,
      slugTheme
    } = this.props;

    if (prevSendStatus === STATUS_LOADING && sendStatus === STATUS_SUCCESS) {
      resetCF7ContactFormStatus();
    }

    if (!!formId && formId !== -1 && prevFormId !== formId) {
      fetchSingleCF7FormContact(formId);
    }

    if (slugTheme !== prevProps.slugTheme || currentThemeTitle !== prevCurrentThemeTitle) {
      this.setInitialValuesState();
    }
  }

  setInitialValuesState: () => void = () => {
    const { currentThemeTitle, initialValues } = this.props;

    let newInitialValues = initialValues;
    let subject = currentThemeTitle;

    if (subject) {
      newInitialValues = { ...initialValues, [SUBJECT_FIELD_NAME]: subject };
    }

    this.setState({ initialValues: newInitialValues });
  };

  render() {
    const { fetchStatus, sendStatus, singleContactForm, title, titleClass, titleTag } = this.props;
    const { initialValues } = this.state;

    if (fetchStatus === STATUS_LOADING || sendStatus === STATUS_LOADING) {
      return <Loading isWhite />;
    }

    return (
      <>
        {title && titleTag === 'h3' && <H3Title title={title} titleClass={titleClass} />}
        <CF7Form {...singleContactForm} initialValues={initialValues} />
      </>
    );
  }
}

export default ContactForm7;
